export default new Vue();